// frontend/src/components/VideoPlayerFullscreen.js
// Shared fullscreen YouTube player. Callers pass a resolved embed URL + orientation.
// Mirrors StudyMaterialViewer's Android lifecycle so hardware-back and the
// YouTube-escape recovery behave identically.
import React, { useEffect } from 'react';

const VideoPlayerFullscreen = ({ embedUrl, orientation = 'horizontal', title = '', onClose }) => {
    const isVertical = orientation === 'vertical';

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        // Tell Android a viewer is open so hardware-back routes to us
        if (window.Android && window.Android.setViewerOpen) {
            window.Android.setViewerOpen(true);
        }

        // Enter the correct native fullscreen mode
        if (isVertical) {
            if (window.Android && window.Android.enterVideoModePortrait) {
                window.Android.enterVideoModePortrait();
            } else if (window.Android && window.Android.enterVideoMode) {
                // Fallback for older app builds without the portrait method
                window.Android.enterVideoMode();
            }
        } else {
            if (window.Android && window.Android.enterVideoMode) {
                window.Android.enterVideoMode();
            }
        }

        const handleAndroidBack = () => { onClose(); };
        window.addEventListener('androidBack', handleAndroidBack);

        return () => {
            document.body.style.overflow = '';
            if (window.Android && window.Android.exitVideoMode) {
                window.Android.exitVideoMode();
            }
            window.removeEventListener('androidBack', handleAndroidBack);
            if (window.Android && window.Android.setViewerOpen) {
                window.Android.setViewerOpen(false);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const src = embedUrl
        ? `${embedUrl}${embedUrl.includes('?') ? '&' : '?'}rel=0&modestbranding=1`
        : '';

    return (
        <div style={{ position: 'fixed', inset: 0, background: '#000', zIndex: 9999, display: 'flex', flexDirection: 'column' }}>
            <button
                onClick={onClose}
                style={{
                    position: 'absolute', top: '0.5rem', right: '0.5rem', zIndex: 10000,
                    background: 'rgba(0,0,0,0.6)', border: 'none', color: '#fff', borderRadius: '50%',
                    width: '2rem', height: '2rem', cursor: 'pointer', fontSize: '0.85rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}
                aria-label="Close video"
            >✕</button>

            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000' }}>
                <div style={isVertical
                    ? { height: '100%', maxHeight: '100%', aspectRatio: '9/16', width: 'auto' }
                    : { width: '100%', maxWidth: '1100px', aspectRatio: '16/9' }
                }>
                    {src ? (
                        <iframe
                            src={src}
                            title={title || 'video'}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                            allowFullScreen
                            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                        />
                    ) : (
                        <p style={{ color: '#ccc' }}>Video unavailable.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VideoPlayerFullscreen;